import { Grid, VStack } from "@chakra-ui/react";
import EntityProfileEditModeButton from "../../../../entityProfileModal/components/EntityProfileEditModeButton";
import {
  EntityProfileErrorState,
  EntityProfileLoadingState,
} from "../../../../entityProfileModal/components/EntityProfileFeedback";
import type { CaregiverId } from "../../../../../shared/schema/schema";
import { CaregiverStaffingPreferenceColumn } from "./components/CaregiverStaffingPreferenceColumn";
import { useCaregiverProfileStaffingPreferencesController } from "./CaregiverProfileStaffingPreferencesSection.hooks";
import {
  caregiverStaffingDetailColumns,
  caregiverStaffingPreferenceColumns,
} from "./staffingPreferences.utils";

type Props = {
  caregiverId: CaregiverId;
};

export default function CaregiverProfileStaffingPreferencesSection(props: Props) {
  const controller = useCaregiverProfileStaffingPreferencesController(props.caregiverId);
  const { staffingPreferencesQuery } = controller;

  if (staffingPreferencesQuery.isLoading) {
    return <EntityProfileLoadingState label="Loading staffing preferences" />;
  }

  if (staffingPreferencesQuery.isError) {
    return (
      <EntityProfileErrorState
        label="Could not load staffing preferences."
        onRetry={() => controller.refetchPreferences()}
      />
    );
  }

  if (controller.preferences === undefined) {
    return <EntityProfileLoadingState label="Loading staffing preferences" />;
  }

  const preferences = controller.preferences;

  return (
    <VStack alignItems="stretch" spacing={7}>
      <EntityProfileEditModeButton
        isDisabled={controller.isUpdating}
        isEditing={controller.isEditing}
        label="Edit"
        onClick={controller.toggleEditMode}
      />

      <Grid gap={8} templateColumns={{ base: "1fr", lg: "repeat(3, minmax(0, 1fr))" }}>
        {caregiverStaffingPreferenceColumns.map((fields, index) => (
          <CaregiverStaffingPreferenceColumn
            key={index}
            draft={controller.draft}
            fields={fields}
            preferences={preferences}
            onChangeDraft={controller.setDraft}
            onCommitDraft={controller.commitDraft}
          />
        ))}
      </Grid>

      <Grid gap={8} templateColumns={{ base: "1fr", lg: "repeat(2, minmax(0, 1fr))" }}>
        {caregiverStaffingDetailColumns.map((fields, index) => (
          <CaregiverStaffingPreferenceColumn
            key={index}
            draft={controller.draft}
            fields={fields}
            preferences={preferences}
            onChangeDraft={controller.setDraft}
            onCommitDraft={controller.commitDraft}
          />
        ))}
      </Grid>
    </VStack>
  );
}
